<template>
  <div class="reg" >
    <div class="reg_box">
      <span>受邀人邮箱：</span>
      <el-input v-model="email" placeholder="username@company.com"></el-input>
    </div>
    <div class="reg_box">
      <span>邮箱内容：</span>
      <el-card shadow="always" >
        <span class="always-span">本邮件来自于中国工程科技专家库项目，由用户：{{user.Name}} 邀请您加入中国工程科技专家库。如果您同意加入，请点击下方链接：</span>
        <el-button type="primary"  size="medium" @click="join"> 立即加入</el-button>
        <!-- <el-link type="primary" :underline="false" href="">立即加入</el-link> -->
        <span class="always-span">如您不愿意加入，请忽略此邮件。</span>
        <span class="always-span">感谢您的查看</span>
        <span class="always-span" style="text-align: right;">中国工程科技专家库</span>
      </el-card>
    </div>
    <div  style="text-align: center; margin-bottom: 40px;">
      <el-button type="primary" size="medium" @click="send"  :disabled="!email" :loading='loading'>{{loading?'发生中':'发送'}}</el-button>
    </div>
  </div>
</template>

<script>
import { sendEmail } from '@/api/center'
export default {
  name: 'reg',

  props: {
    isHttp: {
      type: String

    }
  },
  data () {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      email: '',
      loading: false
    }
  },
  methods: {
    send () {
      // eslint-disable-next-line no-useless-escape
      var pattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
      if (!pattern.test(this.email)) {
        this.$message({
          showClose: true,
          message: '邮件地址格式错误',
          offset: 200
        })
        return
      }
      let data = {

        mail: this.email,
        body: '本邮件来自于中国工程科技专家库项目，由用户：' + this.user.Name + '  邀请您加入中国工程科技专家库。如果您同意加入，请点击下方链接：<br>↵                        <a href="http://expert.ckcest.cn/" class="operation">立即加入</a><br>↵                        如您不愿意加入，请忽略此邮件。<br>↵                        感谢您的查看。<br><span class="right float">中国工程科技专家库</span>↵                   '
      }
      this.loading = true
      sendEmail(data).then(res => {
        this.loading = false
        this.$message({
          showClose: true,
          message: res.msg,
          offset: 200
        })
      })
    },
    join () {
      window.location.href = 'http://expert.ckcest.cn'
    }
  },
  watch: {},
  mounted () {}
}
</script>

<style lang="scss">
.reg {
  padding: 0 40px;
  .reg_box {
    margin: 40px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    span {
      margin-right: 20px;
      display: inline-block;
      width: 100px;
      text-align: right;
    }
    .el-input {
      width: 15.625rem;
    }
    .el-card {
      width: 33rem;
      .always-span {
        width: 30rem;
        text-align: left;
        line-height: 40px;
        text-indent: 2em;
      }
      .el-button{
        margin-left: 2em;
      }

    }
    .el-button{
      span{
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/center/menu/reg.vue